import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../../client';
import { getHosts, getState, linkHost } from '../../services/smartthermostat/HostsService';

export const useHostsGetHosts = createDCHook('getHosts', collapseDataFromCall(getHosts), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});

export const useHostsGetState = createDCHook('getState', collapseDataFromCall(getState), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});

export const useHostsLinkHost = createMutationHook(
  collapseDataFromCall(collapseParams(collapseParams(linkHost, 'requestBody', 'data'), 'data', 'authorizationTicket')),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['authorizationTicket'] },
    ],
  },
);
